import groq from "groq";
import { MediaObjectQuery } from "~/app/queries/molecules/MediaObjectQuery";
import { DesignQuery } from "~/app/queries/atoms/DesignQuery";
import { ButtonQuery } from "~/app/queries/atoms/ButtonQuery";
export const CallToActionQuery = groq`
  _type == 'CallToAction' => {
    ...,
    callToActions[] {
      ...,
      ${ButtonQuery},
      ${MediaObjectQuery},
    },
    ${DesignQuery},
  }
`;
